import loadable from '@loadable/component';

export const getCollapsibleListData = loadable.lib(() =>
  import(
    /* webpackChunkName: "get-collapsible-list-faq-data" */
    './get-collapsible-list-faq-data'
  ),
);
